var render = function render(){var _vm=this,_c=_vm._self._c;return _c('conteudo',{attrs:{"ajax":false}},[_c('race-selector'),_c('transition',{attrs:{"name":"slide","appear":""}},[_c('div',{staticClass:"trecho-info mt-2"},[_c('trecho-info',{attrs:{"trecho":_vm.currentCheckpoint}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }